import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import CustomLoader from '../../../common/CustomLoader';
import ConstructorDetailTable from './ConstructorDetailTable';
import { DEFAULT_COLLECTION_CONSTRUCTORS } from '../../../../common/utils/collectionConstants';
import showAlert from '../../../../common/utils/alert';
import TooltipInfo from '../../../../common/docs/TooltipInfo';
import { description } from '../../../../common/utils/event_constants';
export default class ConstructorFieldDetail extends Component {
  static propTypes = {
    constructors: PropTypes.array.isRequired,
    projectId: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired,
    collection: PropTypes.object.isRequired,
  };
  handleDelete = (constructorId) => {
    const { projectId, collection, version } = this.props;
    const { uuid } = collection;
    const preConfirm = () => {
      this.props.actions.deleteConstructor({
        constructorId,
        version,
        projectId,
        collectionUuid: uuid,
      });
    };
    showAlert("You won't be able to revert this.", preConfirm, 'Yes, delete it!');
  };
  isSystemDefault = (constructorName) => {
    let isSystemDefault = false;
    if (constructorName && DEFAULT_COLLECTION_CONSTRUCTORS.includes(constructorName)) {
      isSystemDefault = true;
    }
    return isSystemDefault;
  };
  render() {
    const { constructors, showConstructorDeleteLoader, deleteFlag } = this.props;
    return (
      <Accordion allowZeroExpanded>
        {constructors.map((constr) => (
          <AccordionItem
            key={constr.customConstructorName}
            {...(this.isSystemDefault(constr.customConstructorName) && {
              dangerouslySetExpanded: false,
            })}
          >
            <AccordionItemHeading>
              <AccordionItemButton>
                <i className={`wb`}></i> <strong>{constr.customConstructorName}</strong>
                {this.isSystemDefault(constr.customConstructorName) && ` (system default)`}
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <div className="col-md-12 col-lg-12 table-responsive">
                {constr.customConstructorName !== 'Default Constructor' ? (
                  <ConstructorDetailTable key={constr.uuid} constructor={constr} />
                ) : (
                  <p> Default Constructor </p>
                )}
              </div>
              {!this.isSystemDefault(constr.customConstructorName) && (
                <div className="col-12 text-right pb-2">
                  <button
                    type="button"
                    className="btn btn-sm btn-theme-delete btn-md"
                    style={{ cursor: deleteFlag ? 'pointer' : 'not-allowed' }}
                    onClick={() => (deleteFlag ? this.handleDelete(constr.uuid) : undefined)}
                    disabled={showConstructorDeleteLoader}
                  >
                    <i className="wb webconnect-trash-regular"></i>&nbsp;Delete&nbsp;
                    {deleteFlag ? null : (
                      <TooltipInfo
                        title={description}
                        headerText={`Permission Disabled!`}
                        showHeader={true}
                        showArrow={true}
                      />
                    )}
                    <CustomLoader loading={showConstructorDeleteLoader} />
                  </button>
                </div>
              )}
            </AccordionItemPanel>
          </AccordionItem>
        ))}
      </Accordion>
    );
  }
}
